<template>
  <div>
    <search-agents-profile-product @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findAgentsProfileProducts } from '@/api/agents_profile_product'
import Pagination from '@/components/Pagination'
import SearchAgentsProfileProduct from '@/views/agents_profile_products/Search'

export default {
  name: 'AgentsProfileProductList',
  components: {
    Pagination,
    SearchAgentsProfileProduct
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: { total_count: 0 },
      query: { effective: '1', per_page: 10 },
      columns: [
        { title: '产品名称', dataIndex: 'name', width: 180 },
        { title: '有效性', dataIndex: 'effective', width: 100 },
        { title: '导入时间', dataIndex: 'created_at', width: 170 }
      ]
    }
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findAgentsProfileProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
